export default build =>
    build.mutation({
        query(payload) {
            console.log("payloaddd",payload)
            return {
                url: '/result/getPersonalResult',//for antarim
             //  url: '/result/getPersonalResultTse', //for antim 
            // url: '/result/getPersonalResultTseAntim', //for antim                               
                method: 'POST',
                body: payload,
               
            };
        },
       // invalidatesTags: ['allDistricts'],
    })
